import React, { useState, useCallback } from "react"
import Webcam from "react-webcam"
import CameraIcon from "images/inline/ugc/camera.svg"
import Modal from "@material-ui/core/Modal"
import Backdrop from "@material-ui/core/Backdrop"
import "./webcam.scss"

const WebcamCapture = ({onPhotoSave}) => {
  const webcamRef = React.useRef(null)
  const [imgSrc, setImgSrc] = useState(null)
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot()
    setImgSrc(imageSrc)
  }, [webcamRef, setImgSrc])
  const retake = () => {
    setImgSrc(null)
  }
  const closeModal = () => {
    setIsModalOpen(false)
  }
  const handleSaveWebcamPic = () => {
    onPhotoSave(imgSrc)
  }
  return (
    <>
      <button
        className={`btn open-webcam-button dropzone-button`}
        onClick={() => {
          setIsModalOpen(true)
        }}>
        <CameraIcon /><span>Take a picture</span>
      </button>
      <Modal
        tabIndex={0}
        className={"0"}
        open={isModalOpen}
        onBackdropClick={closeModal}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}>
        <div className={`webcam-modal on`}>
          <div>
            <div className={`capture-frame`}>
              {!imgSrc && <Webcam audio={false} ref={webcamRef} screenshotFormat="image/jpeg" />}
              {imgSrc && <img src={imgSrc} />}
            </div>
            <div className={`capture-ctrls`}>
              {" "}
              {!imgSrc &&  <button className={`capture btn`} onClick={capture}>
                Capture
              </button> }
              {imgSrc && (
                <>
              <button className={`capture btn`} onClick={retake}>
                Retake
              </button>
              <button className={`capture btn`} onClick={() => { 
                handleSaveWebcamPic()
                closeModal()
              }}>
             Save
            </button>
            </>
              )}
            </div>
          </div>
          <button className={`modal-close top-level-close`} onClick={closeModal} aria-label="Close"></button>
        </div>
      </Modal>
    </>
  )
}

export default WebcamCapture
